import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth';

// Wrapper for the volunteering section — five internal tabs on top in
// the order the operator prescribed:
//   1. قائمة المتطوعين           (list view — all statuses)
//   2. موافقة مسؤول المتطوعين  (REVIEW queue)
//   3. موافقة الـ HR              (HR queue)
//   4. الأنشطة                   (activities)
//   5. طلبات الإدارات           (staffing requests)
// The old "التقارير" tab was dropped per the same operator direction.
export default function VolunteeringWrapperPage() {
  const { permissions } = useAuth();
  const tab = (to: string, label: string) => (
    <NavLink to={to} end className={({ isActive }) => `home-tab ${isActive ? 'active' : ''}`}>
      {label}
    </NavLink>
  );

  return (
    <>
      <div className="home-tabs" role="tablist" aria-label="أقسام التطوع">
        {tab('/volunteering/volunteers', 'قائمة المتطوعين')}
        {permissions.canApproveVolunteeringCoordinator && tab('/volunteering/coordinator', 'موافقة مسؤول المتطوعين')}
        {permissions.canApproveVolunteeringHr && tab('/volunteering/hr', 'موافقة الـ HR')}
        {permissions.canVolunteering && tab('/volunteering/activities', 'الأنشطة')}
        {permissions.canVolunteering && tab('/volunteering/staffing', 'طلبات الإدارات')}
      </div>
      <div className="home-tab-panel">
        <Outlet />
      </div>
    </>
  );
}
